export const STATUS = {
  notSubmitted: 'NOT_SUBMITTED',
  verified: 'VERIFIED',
  failed: 'VERIFICATION_FAILED',
};
